import React, { Fragment, useContext } from 'react'
import { Redirect } from 'react-router-dom'
import { Text } from '../../components/text'
import { Form } from '../../components/pdp-form'
import { Box } from '../../components/box'
import { Button } from '../../components/button'
import { Loader, Overlay } from '../../components/loader'
import { Container, Row, Col } from '../../components/grid'
import { BundleCartItem } from '../../components/bundle-cart'
import { useCart } from '../../utils/hooks/useCart'
import { handleSessionError } from '../../utils/error-tracking'
import { useBundleCart } from '../../utils/hooks/useBundleCart'
import { useTrackImpression } from '../../utils/hooks/useTrackImpression'
import { getFirstItemCurrencyCode } from '../../utils/get-currency-code'
import { CurrencyFormat } from '@paypalcorp/worldready'
import {
  Message,
  Context as WorldReadyContext,
} from '@paypalcorp/worldready-react'

const BundlePDPForm = () => {
  const cart = useCart()
  const bundleCart = useBundleCart()
  const worldready = useContext(WorldReadyContext)

  if (bundleCart.error) {
    handleSessionError(bundleCart.error)
    return <Redirect to="/error" />
  }

  if (!bundleCart.items.length) {
    return (
      <Box py="x8" textAlign="center">
        <Text textStyle="h3" mb="x3">
          <Message id="pages/custom-bundles.checkout.empty" />
        </Text>
        <Button variant="secondary" href="/byob">
          <Message id="pages/custom-bundles.checkout.cta" />
        </Button>
      </Box>
    )
  }

  return (
    <Fragment>
      <Row my="x3">
        <Col xs={8}>
          <Text textStyle="h3">
            <Message id="pages/custom-bundles.checkout.title" />
          </Text>
        </Col>
        <Col ml="auto">
          <Text textAlign="right" textStyle="h3">
            {new CurrencyFormat(worldready, {
              currency: getFirstItemCurrencyCode(bundleCart.items),
            }).format(bundleCart.total / 100)}
          </Text>
        </Col>
      </Row>
      <Box mb={5}>
        {bundleCart.items.map((item) => (
          <BundleCartItem
            key={`bundle-cart-item-${item.sku}`}
            item={item}
            handleRemove={() => bundleCart.remove(item)}
          />
        ))}
      </Box>
      <Box mb={3}>
        <Form
          pgrp="main:consumer:gifts:byobadd:"
          page="main:consumer:gifts:byobadd:addtocart:::"
          cart={cart}
          bundleCart={bundleCart}
        />
      </Box>
      {bundleCart.updating && (
        <Overlay>
          <Box m="auto">
            <Loader />
            <Text textStyle="h5" mt="x10">
              <Message id="pages/custom-bundles.cart.updating" />
            </Text>
          </Box>
        </Overlay>
      )}

      {cart.loading && (
        <Overlay>
          <Box m="auto">
            <Loader />
            <Text textStyle="h5" mt="x10">
              <Message id="pages/custom-bundles.cart.adding" />
            </Text>
          </Box>
        </Overlay>
      )}
    </Fragment>
  )
}

const BundlesPDP = () => {
  useTrackImpression(
    'main:consumer:gifts:byobadd:',
    'main:consumer:gifts:byobadd::::',
  )

  return (
    <Container>
      <Row py={3}>
        <Col md={{ span: 8, offset: 2 }} lg={{ span: 6, offset: 3 }}>
          <BundlePDPForm />
        </Col>
      </Row>
    </Container>
  )
}

export default BundlesPDP
